import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import termsAndConditionsContent from "../../assets/data/companyInfos/termsAndConditions.json";
import "../../assets/styles/components_styles/legalDocs.css";

const BLOCK_RENDERERS = {
  updated: ({ text }, key) => (
    <p key={key} className="legalDocsUpdatedDate">
      {text}
    </p>
  ),
  heading: ({ text }, key) => (
    <h2 key={key} className="legalDocsHeading">
      {text}
    </h2>
  ),
  p: ({ text }, key) => (
    <p key={key} className="legalDocsParagraph">
      {text}
    </p>
  ),
};

const renderPolicyBlock = (block, index) => {
  const renderer = BLOCK_RENDERERS[block?.type] || BLOCK_RENDERERS.p;
  return renderer(block, `${block?.type || "p"}-${index}`);
};

export default function TermsAndConditionsPage() {
  const { meta = {}, blocks = [] } = termsAndConditionsContent;
  const pageTitle = meta.pageTitle || "Terms & Conditions";
  const helmetTitle = meta.helmetTitle || "Terms & Conditions - Pingvite";
  const helmetDescription =
    meta.helmetDescription ||
    "Read Pingvite terms and conditions for event listing, registration, and ticketing services.";
  const helmetKeywords =
    meta.helmetKeywords ||
    "Pingvite terms and conditions, event ticketing terms, platform usage terms";

  return (
    <>
      <HelmetWrapper
        title={helmetTitle}
        description={helmetDescription}
        keywords={helmetKeywords}
      />

      {/* HEADER */}
      <Header isHome={false} />

      {/* CONTENT */}
      <main className="legalDocsPageRoot">
        <section className="legalDocsSection">
          <div className="container">
            <div className="legalDocsContent">
              <h1 className="legalDocsTitle">{pageTitle}</h1>
              <span className="legalDocsTitleUnderline" />

              {blocks.map(renderPolicyBlock)}
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <Footer />
      </main>
    </>
  );
}

